import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Permission, Role, ROLE_PERMISSIONS } from './permission';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
  private currentRoles$ = new BehaviorSubject<Role[]>([]);

  setRoles(roles: Role[]) {
    this.currentRoles$.next(roles);
  }

  getRoles(): Role[] {
    return this.currentRoles$.value;
  }

  roles$ = this.currentRoles$.asObservable();

  private getAllPermissions(roles: Role[]): Permission[] {
    const all = roles.flatMap((role) => ROLE_PERMISSIONS[role] || []);
    return Array.from(new Set(all)); // Duplikate entfernen
  }

  hasPermission(permission: Permission): boolean {
    return this.getAllPermissions(this.getRoles()).includes(permission);
  }

  hasAnyPermission(...permissions: Permission[]): boolean {
    return permissions.some((p) => this.hasPermission(p));
  }
}
